import React from "react";

import IOption from "common/models/IOption";
import { IWidgetProps } from "decorator-form";
import ButtonSelect from "./common/ButtonSelect";

export enum FontWeight {
	LIGHT = "300",
	NORMAL = "400",
	BOLD = "600"
}

const options: IOption[] = [
	{label: "Light", value: FontWeight.LIGHT},
	{label: "Normal", value: FontWeight.NORMAL, default: true},
	{label: "Bold", value: FontWeight.BOLD}
];

const FontWeightWidget: React.SFC<IWidgetProps<string>> = (props) => {
	return <ButtonSelect {...props} options={options} />;
};

export default FontWeightWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/FontWeightWidget.tsx